import React, { FC } from 'react';
import CancellationRules from '@/components/houses/_reusable/houseInfo/rules/cancellationRulesContainer/cancellationRules/CancellationRules';
import CancellationRulesMidterm from '@/components/reusable/cancellationRulesMidterm/CancellationRulesMidterm';
type CancellationRulesContainerProps = {
  cancellationRule: 'easy' | 'medium' | 'hard';
  handleClose: VoidFunction;
  isMidterm: boolean;
};
const CancellationRulesContainer: FC<CancellationRulesContainerProps> = ({
  cancellationRule,
  handleClose,
  isMidterm
}) => {
  return isMidterm ? <CancellationRulesMidterm handleClose={handleClose} data-sentry-element="CancellationRulesMidterm" data-sentry-component="CancellationRulesContainer" data-sentry-source-file="CancellationRulesContainer.tsx" /> : <CancellationRules cancellationRule={cancellationRule} handleClose={handleClose} data-sentry-element="CancellationRules" data-sentry-component="CancellationRulesContainer" data-sentry-source-file="CancellationRulesContainer.tsx" />;
};
export default CancellationRulesContainer;